// extracted by mini-css-extract-plugin
export var icon = "_6k-1";
export var subtext = "_6k-0";